/**
 * The station list of the packstation dialog, a fragment rendered by the packstation module.
 *
 * Markup contract: one scope around the list and the map.
 *   <div x-data="packstationSearch({ locations, markerImage })"
 *        @marker-pick="highlight($event.detail.index)">
 *     <li id="PackstationNumber<i>" x-show="isVisible(<i>)"
 *         :class="{ highlightPackstation: highlighted === <i> }">
 *     <div id="pickupMap" x-data="locationMap(mapOptions)">
 *
 * The pickup fieldset that opened the dialog lives outside it, so the chosen station
 * travels as a window event.
 */

// the first stations answer most searches, the rest waits behind the button
const VISIBLE = 5;

// what the shop stores as the street of a pickup address, one token per station type
const STREETS = {
    packstation: 'Packstation',
    filiale: 'Postfiliale',
    parcelShop: 'Parcelshop',
    accessPoint: 'AccessPoint',
};

/** Turns a carrier record into the address the pickup fieldset fills in. */
function addressOf(location) {
    const isDhl = location.Carrier === 'DHL';
    let type = 'parcelShop';
    let number = location.ParcelshopNumber;

    if (isDhl && location.PackstationNumber !== '') {
        type = 'packstation';
        number = location.PackstationNumber;
    } else if (isDhl && location.PostfilialNumber !== '') {
        type = 'filiale';
        number = location.PostfilialNumber;
    }

    return {
        street: isDhl ? STREETS[type] : STREETS.accessPoint,
        number,
        addInfo: isDhl ? `${location.StreetName} ${location.StreetNumber}` : location.AddressAddition,
        zip: location.ZipCode,
        city: location.City,
        name: isDhl ? `${location.Name2} ${number}` : location.Name1,
        // a post number belongs to a DHL account, a UPS access point does without
        postNumber: isDhl,
        flag: type === 'packstation' ? '1' : '2',
    };
}

document.addEventListener('alpine:init', () => {
    Alpine.data('packstationSearch', ({ locations, markerImage }) => ({
        showAll: false,
        highlighted: null,
        openHours: null,

        init() {
            // $el is the element of the running expression, so the root is taken here
            this.root = this.$el;
        },

        get hasMore() {
            return locations.length > VISIBLE;
        },

        get mapOptions() {
            return {
                markerImage,
                markers: locations.map((location) => ({
                    lat: Number(location.Latitude),
                    lng: Number(location.Longitude),
                    label: location.Carrier === 'DHL' ? location.Name2 : location.Name1,
                })),
            };
        },

        isVisible(index) {
            return this.showAll || index < VISIBLE;
        },

        toggleHours(index) {
            this.openHours = this.openHours === index ? null : index;
        },

        /** A click on a map marker brings its entry into the list and marks it. */
        highlight(index) {
            if (index >= VISIBLE) {
                this.showAll = true;
            }
            this.highlighted = index;
            this.$nextTick(() => {
                this.root.querySelector(`#PackstationNumber${index}`).scrollIntoView({ block: 'nearest' });
            });
        },

        select(index) {
            window.dispatchEvent(new CustomEvent('packstation-picked', { detail: addressOf(locations[index]) }));
            Alpine.store('dialog').close();
        },
    }));
});
